///<amd-module name='StorageDiagnostics'/>

import * as DomHelper from "../Helpers/DomHelper";
import * as BlobHelper from "../Helpers/BlobHelper";
import { DiagnosticStatus, StorageKeys } from "../Interfaces/Interfaces";
import { cancel } from "../Helpers/ExecutionStatus";

const global: Window = window;
const { selfHelp: { resources } } = global;
const { statusIconVals } = DomHelper;

/** Diagnostic data representing the success or failure of the storage tests */
let diagnostics: DiagnosticStatus;
/** String value indicating whether we're testing local or session storage */
let key: StorageKeys = null;

/**
 * Updates blob and updates dom to display results of storage diagnostic tests.
 *
 * @param {string} key which storage is being tested -- "localStorage" or "sessionStorage"
 * @param {string} displayStatus what kind of icon the DOM should display
 * @param {DiagnosticStatus} diagnostic holds data representing whether the test was successful
 * and if not, where the error was thrown.
 */
function endTest(): void {
    if (cancel) {
        return;
    }
    DomHelper.makeBarGrow(key);
    const displayStatus = diagnostics.success ? statusIconVals.success : statusIconVals.error;
    DomHelper.displayStatusIcon(key, displayStatus);
    DomHelper.createMoreDetailsSection(key, diagnostics.details);
    BlobHelper.updateBlob(key, diagnostics);
}

/**
 * Checks if space available in Local / Session storage Storage
 */
function checkStorage(): void {
    const storage = key === "localStorage" ? window.localStorage : window.sessionStorage;
    let status: DiagnosticStatus = { success: null };
    if (storage) {
        if (cancel) {
            return;
        }
        try {
            storage.setItem("testkey", "testval");
            if (storage.getItem("testkey") !== "testval") {
                status = {
                    success: false,
                    details: `${resources.Storage_readError} ${resources.Storage_clearBrowserSuggestion}`,
                    statusText: "Error:ThrewOnRead",
                };
            } else {
                status = { success: true, details: resources.Storage_success };
                storage.removeItem("testkey");
            }
        } catch (err) {
            status = {
                success: false,
                details: `${resources.Storage_writeError} ${resources.Storage_clearBrowserSuggestion}`,
                statusText: "Error:ThrewOnWrite",
            };
        }
    } else {
        status = {
            success: false,
            details: resources.Storage_unsupported,
            statusText: "Error:Unavailable",
        };
    }

    diagnostics = status;
}

/**
 * Triggers beginning of test and update of DOM.
 *
 * @param {string} storageType indicates which storage to check - "localStorage" or "sessionStorage"
 */
export function startTest(storageType: StorageKeys): void {
    key = storageType;
    diagnostics = { success: null, statusText: null };

    DomHelper.displayStatusIcon(storageType, statusIconVals.inProgress);
    if (cancel) { return endTest(); }
    checkStorage();
    endTest();
}
